import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch} from 'react-router-dom';
import { Provider } from 'react-redux';
import 'bootstrap';

import store from './stores';
import Home from "./pages/Home";
import Products from "./pages/Products";
import Detail from "./pages/Detail";
import Cart from "./pages/Cart";

class App extends Component {
    render() {
        return (
            <Provider store={ store }>
                <Router>
                    <div className="App">
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/products/:type" component={Products} />
                            <Route exact path="/product-detail/:id" component={Detail} />
                            <Route exact path="/cart" component={Cart} />
                        </Switch>
                    </div>
                </Router>
            </Provider>
        );
    }
}

export default App;
